import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { SwapHoriz as SwapIcon } from '@mui/icons-material';

function TassTaskBoundary({ topic, timestamp }) {
  return (
    <Box sx={{ my: 1.5, px: 2 }}>
      <Divider>
        <Box
          display="flex"
          alignItems="center"
          gap={0.5}
          sx={{
            px: 1.5,
            py: 0.25,
            borderRadius: 1,
            backgroundColor: 'grey.50'
          }}
        >
          <SwapIcon sx={{ fontSize: 12, color: 'text.disabled' }} />
          <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.65rem' }}>
            Switched to: {topic}
          </Typography>
          {timestamp && (
            <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: '0.6rem', ml: 0.5 }}>
              {new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </Typography>
          )}
        </Box>
      </Divider>
    </Box>
  );
}

export default TassTaskBoundary;
